export function isSinglePermissionAdvancedObject(singlePermission) {
    return typeof singlePermission === 'object';
}
//# sourceMappingURL=SinglePermission.js.map